// Fix to "global is not defined" error
(window as any).global = window;
